export default __webpack_public_path__ + "static/smsc_cat-3225a18a1dea4a453e9efb02327f94b5.png";